import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import api, { API_BASE_URL } from "../axios";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import gsap from "gsap";
import { Check } from "lucide-react";
import LinkIcon from "../componant/ui/LinkIcon";

async function loginUser(credentials, islog) {
  if (!islog) {
    return fetch(`${API_BASE_URL}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(credentials),
    })
      .then((data) => data.json())
      .catch(() => ({ error_message: i18n.t("Something went wrong. Please try again.") }));
  }
}

const labelClasses = "mb-1.5 block text-sm font-medium text-ink-700";

const inputClasses =
  "w-full h-11 rounded-xl border-2 border-ink-200 bg-ink-50/60 px-4 text-base text-ink-800 placeholder:text-ink-400 " +
  "transition-colors duration-200 focus:border-accent-500 focus:bg-white focus:outline-none";

const primaryButtonClasses =
  "h-11 w-full rounded-full bg-accent-500 font-semibold text-white shadow-glow-accent transition-colors duration-200 " +
  "hover:bg-accent-600 active:scale-[0.97] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent-500";

const linkClasses = "text-sm font-medium text-accent-500 hover:text-accent-600";

const LOGIN_SOCIALS = [
  { icon: "fa-instagram", color: "#E1306C", className: "left-6 top-10 -rotate-6" },
  { icon: "fa-youtube", color: "#FF0000", className: "right-8 top-24 rotate-6" },
  { icon: "fa-tiktok", color: "#000000", className: "left-10 bottom-24 rotate-3" },
  { icon: "fa-facebook", color: "#1877F2", className: "right-10 bottom-12 -rotate-3" },
  { icon: "fa-github", color: "#000000", className: "right-4 bottom-1/3 -rotate-6" },
  { icon: "fa-behance", color: "blue", className: "left-4 bottom-1/2 -rotate-3" },
  { icon: "fa-telegram", color: "#0088CC", className: "left-1/2 top-10 -rotate-3" },
];

const Field = ({ label, ...props }) => (
  <div>
    <label className={labelClasses}>{label}</label>
    <input className={inputClasses} {...props} />
  </div>
);

const Login = ({ setToken }) => {
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();
  const [email, setemail] = useState();
  const [conpassword, setconpassword] = useState();
  const [islog, setislog] = useState(false);
  const [isreg, setisreg] = useState(true);
  const [isforget, setisforget] = useState(!true);
  const [errorMessage, setErrorMessage] = useState('');
  const [loginError, setLoginError] = useState('');
  const [regError, setRegError] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [isverify, setisverify] = useState(false);
  const [verifyEmail, setVerifyEmail] = useState('');
  const [verifyCode, setVerifyCode] = useState('');
  const [verifyError, setVerifyError] = useState('');
  const [codeExpiresAt, setCodeExpiresAt] = useState(null);
  const [secondsLeft, setSecondsLeft] = useState(0);
  const [resendSecondsLeft, setResendSecondsLeft] = useState(0);

  // Inline pre-registration email verification
  const [regCodeSent, setRegCodeSent] = useState(false);
  const [regEmailVerified, setRegEmailVerified] = useState(false);
  const [regVerifiedEmail, setRegVerifiedEmail] = useState('');
  const [regVerifyCode, setRegVerifyCode] = useState('');
  const [regVerifySending, setRegVerifySending] = useState(false);
  const [regVerifyChecking, setRegVerifyChecking] = useState(false);
  const [regVerifyError, setRegVerifyError] = useState('');
  const [regResendSecondsLeft, setRegResendSecondsLeft] = useState(0);
  const panelRef = useRef(null);

  useEffect(() => {
    if (!isverify) return;
    const interval = setInterval(() => {
      setSecondsLeft(
        codeExpiresAt ? Math.max(0, Math.ceil((codeExpiresAt - Date.now()) / 1000)) : 0
      );
      setResendSecondsLeft((s) => Math.max(0, s - 1));
    }, 1000);
    return () => clearInterval(interval);
  }, [isverify, codeExpiresAt]);

  useEffect(() => {
    if (regResendSecondsLeft <= 0) return;
    const interval = setInterval(() => {
      setRegResendSecondsLeft((s) => Math.max(0, s - 1));
    }, 1000);
    return () => clearInterval(interval);
  }, [regResendSecondsLeft]);

  useEffect(() => {
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion || !panelRef.current) return;

    const ctx = gsap.context(() => {
      const chips = gsap.utils.toArray("[data-login-chip]");

      gsap.from(chips, {
        opacity: 0,
        y: 20,
        scale: 0.85,
        stagger: 0.12,
        duration: 0.6,
        ease: "power3.out",
        delay: 0.2,
      });

      chips.forEach((chip, i) => {
        gsap.to(chip, {
          y: "+=10",
          duration: 2 + i * 0.3,
          repeat: -1,
          yoyo: true,
          ease: "sine.inOut",
          delay: 0.6 + i * 0.15,
        });
      });
    }, panelRef);

    return () => ctx.revert();
  }, []);

  const startVerification = (emailAddr) => {
    setVerifyEmail(emailAddr);
    setVerifyCode('');
    setVerifyError('');
    setCodeExpiresAt(Date.now() + 10 * 60 * 1000);
    setResendSecondsLeft(0);
    setisverify(true);
  };

  const handlelogin = async (e) => {
    e.preventDefault();
    setLoginError('');
    const token = await loginUser({
      username,
      password,
    });
    if (token?.user || false) {
      setToken(token);

      window.location.reload();
    } else if (token?.error_code === 'email_not_verified') {
      startVerification(token.email);
    } else {
      setLoginError(token?.error_message || t('Invalid username or password'));
    }
  };
  const handleforget = async (e) => {
    e.preventDefault();
    api
      .post("/forget", {
        email,
      })
      .then(({ data }) => {
        Swal.fire({
          icon: "success",
          title: t("The link was sent to your email"),
          text: t("check your email"),
        });
      })
      .catch((data) => {
        Swal.fire({
          icon: "error",
          title: t("Oops..."),
          text: t("Email not found"),
        });
      });
  };

  const handleUsernameChange = (e) => {
    const value = e.target.value;
    if (value.includes(' ')) {
      setErrorMessage(t('Username cannot contain spaces'));
    } else {
      setErrorMessage('');
    }
    setUserName(value);
  };

  const handleRegEmailChange = (e) => {
    const value = e.target.value;
    setemail(value);
    // Any change to the email invalidates a previous verification.
    if (value !== regVerifiedEmail) {
      setRegEmailVerified(false);
    }
    setRegCodeSent(false);
    setRegVerifyCode('');
    setRegVerifyError('');
  };

  const handleSendRegCode = async () => {
    setRegVerifyError('');
    if (!email) {
      setRegVerifyError(t('Please enter your email first'));
      return;
    }
    setRegVerifySending(true);
    try {
      await api.post("/send-verification-code", { email });
      setRegCodeSent(true);
      setRegVerifyCode('');
      setRegResendSecondsLeft(60);
    } catch (error) {
      setRegVerifyError(error.response?.data?.error_message || t('An error occurred'));
    } finally {
      setRegVerifySending(false);
    }
  };

  const handleCheckRegCode = async () => {
    setRegVerifyError('');
    if (!regVerifyCode) {
      setRegVerifyError(t('Please enter the code sent to your email'));
      return;
    }
    setRegVerifyChecking(true);
    try {
      await api.post("/check-verification-code", {
        email,
        code: regVerifyCode,
      });
      setRegEmailVerified(true);
      setRegVerifiedEmail(email);
    } catch (error) {
      setRegVerifyError(error.response?.data?.error_message || t('An error occurred'));
    } finally {
      setRegVerifyChecking(false);
    }
  };

  const handlereg = async (e) => {
    e.preventDefault();
    setRegError('');

    // Check for errors before proceeding
    if (errorMessage) {
      setRegError(errorMessage);
      return;
    }

    // Check if password and confirm password match
    if (password !== conpassword) {
      setRegError(t('Passwords do not match'));
      return;
    }

    if (!regEmailVerified || regVerifiedEmail !== email) {
      setRegError(t('Please verify your email before submitting'));
      return;
    }

    // Proceed with the form submission
    try {
      const response = await api.post("/register", {
        username,
        password,
        email,
      });

      setToken(response.data);
      window.location.reload();
    } catch (error) {
      let apiErrorMessage = '';
      if (error.response && error.response.data && error.response.data.errors) {
        let errors = Object.values(error.response.data.errors);
        apiErrorMessage = errors.join(' ');
      } else if (error.response?.data?.error_message) {
        apiErrorMessage = error.response.data.error_message;
      }
      setRegError(apiErrorMessage || t('An error occurred'));
    }
  };
  const handleVerifyCode = async (e) => {
    e.preventDefault();
    setVerifyError('');
    try {
      const response = await api.post("/verify-email", {
        email: verifyEmail,
        code: verifyCode,
      });
      setToken(response.data);
      window.location.reload();
    } catch (error) {
      setVerifyError(error.response?.data?.error_message || t('An error occurred'));
    }
  };

  const handleResendCode = async () => {
    if (resendSecondsLeft > 0) return;
    setVerifyError('');
    try {
      await api.post("/resend-verification", {
        email: verifyEmail,
      });
      setCodeExpiresAt(Date.now() + 10 * 60 * 1000);
      setResendSecondsLeft(60);
    } catch (error) {
      setVerifyError(error.response?.data?.error_message || t('An error occurred'));
    }
  };

  const formatTime = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-8 min-h-[90vh] w-full items-center justify-center bg-ink-50 px-4 py-12">
      <div className="flex flex-col items-center gap-1">
        <p className="text-center font-display text-3xl font-semibold text-ink-800">
          {t("All your links, in one place")}
        </p>
      </div>
      <div className="grid w-full max-w-4xl overflow-hidden rounded-2xl bg-white shadow-elevated md:grid-cols-2">
        <div ref={panelRef} className="relative hidden flex-col items-center justify-center gap-10 overflow-hidden bg-white p-10 md:flex">
          <img
            alt=""
            src={`${process.env.PUBLIC_URL}/images/11.png`}
            className="absolute inset-0 h-full w-full object-cover"
            style={{
              WebkitMaskImage: "radial-gradient(circle at 50% 45%, black 35%, transparent 72%)",
              maskImage: "radial-gradient(circle at 50% 45%, black 35%, transparent 72%)",
            }}
          />

          {LOGIN_SOCIALS.map((s) => (
            <div
              key={s.icon}
              data-login-chip
              className={`absolute flex h-14 w-14 items-center justify-center rounded-2xl bg-white shadow-elevated ${s.className}`}
            >
              <LinkIcon value={s.icon} color={s.color} className="text-2xl sm:text-3xl" />
            </div>
          ))}
        </div>

        <div className="flex flex-col justify-center p-8 sm:p-10">
          <div className="mb-8 flex rounded-full bg-ink-50 p-1">
            <button
              type="button"
              className={`flex-1 rounded-full py-2.5 text-sm font-semibold transition-colors duration-200 ${islog ? "bg-accent-500 text-white shadow-glow-accent" : "text-ink-500 hover:text-ink-800"
                }`}
              onClick={() => {
                setislog(true);
                setisreg(false);
                setisforget(!true);
              }}
            >
              {t("Register")}
            </button>
            <button
              type="button"
              className={`flex-1 rounded-full py-2.5 text-sm font-semibold transition-colors duration-200 ${!islog ? "bg-accent-500 text-white shadow-glow-accent" : "text-ink-500 hover:text-ink-800"
                }`}
              onClick={() => {
                setisreg(true);
                setislog(false);
                setisforget(!true);
              }}
            >
              {t("Login")}
            </button>
          </div>

          <div
            className="flex-col items-stretch"
            style={{ display: islog || isverify ? "none" : "flex" }}
          >
            <h1 className="mb-6 font-display text-2xl font-bold text-ink-900">
              {t("Please Log In")}
            </h1>
            <form className="flex flex-col gap-5" onSubmit={handlelogin}>
              <Field
                required
                type="text"
                label={t("Username")}
                onChange={(e) => setUserName(e.target.value)}
              />
              <div>
                <Field
                  type="password"
                  required
                  label={t("Password")}
                  onChange={(e) => setPassword(e.target.value)}
                />
                {loginError && (
                  <p className="mt-2 text-sm text-red-500">{loginError}</p>
                )}
              </div>
              <div className="flex items-center justify-between">
                <label className="flex items-center gap-2 text-sm text-ink-600">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                    className="h-4 w-4 rounded border-ink-300 text-accent-500 focus:ring-accent-500"
                  />
                  {t("Remember me")}
                </label>
                <button
                  type="button"
                  className={linkClasses}
                  onClick={() => {
                    setislog(!false);
                    setisforget(true);
                    setisreg(!false);
                  }}
                >
                  {t("Forgot your password?")}
                </button>
              </div>
              <button type="submit" className={primaryButtonClasses}>
                {t("Submit")}
              </button>
            </form>
            <button
              type="button"
              className="mt-6 text-center text-sm font-medium text-ink-500 hover:text-accent-500"
              onClick={() => {
                setisforget(!true);
                setislog(!false);
                setisreg(!true);
              }}
            >
              {t("Don't have an account?")}
            </button>
          </div>

          <div
            className="flex-col items-stretch"
            style={{ display: isreg || isverify ? "none" : "flex" }}
          >
            <h1 className="mb-6 font-display text-2xl font-bold text-ink-900">
              {t("Register Please")}
            </h1>
            <form className="flex flex-col gap-5" onSubmit={handlereg}>
              <Field
                label={t("User Name")}
                required
                type="text"
                onChange={handleUsernameChange}
                value={username}
              />
              <div>
                <label className={labelClasses}>{t("email")}</label>
                <div className="flex gap-2">
                  <input
                    className={inputClasses}
                    required
                    type="email"
                    value={email || ''}
                    readOnly={regEmailVerified && regVerifiedEmail === email}
                    onChange={handleRegEmailChange}
                  />
                  {regEmailVerified && regVerifiedEmail === email ? (
                    <span className="flex h-11 shrink-0 items-center gap-1 rounded-xl bg-green-50 px-3 text-sm font-semibold text-green-600">
                      <Check className="w-4 h-4" /> {t("Verified")}
                    </span>
                  ) : (
                    <button
                      type="button"
                      className="h-11 shrink-0 rounded-xl border-2 border-accent-500 px-4 text-sm font-semibold text-accent-500 transition-colors duration-200 hover:bg-accent-50 disabled:cursor-not-allowed disabled:opacity-50"
                      disabled={!email || regVerifySending || regResendSecondsLeft > 0}
                      onClick={handleSendRegCode}
                    >
                      {regResendSecondsLeft > 0
                        ? `${t("Resend")} (${regResendSecondsLeft}s)`
                        : regVerifySending
                          ? t("Sending...")
                          : regCodeSent
                            ? t("Resend")
                            : t("Verify")}
                    </button>
                  )}
                </div>

                {regCodeSent && !regEmailVerified && (
                  <div className="mt-3 flex gap-2">
                    <input
                      className={inputClasses}
                      type="text"
                      inputMode="numeric"
                      maxLength={6}
                      placeholder={t("Enter the 6-digit code")}
                      value={regVerifyCode}
                      onChange={(e) => setRegVerifyCode(e.target.value.replace(/\D/g, ''))}
                    />
                    <button
                      type="button"
                      className="h-11 shrink-0 rounded-xl bg-accent-500 px-4 text-sm font-semibold text-white transition-colors duration-200 hover:bg-accent-600 disabled:cursor-not-allowed disabled:opacity-50"
                      disabled={regVerifyChecking}
                      onClick={handleCheckRegCode}
                    >
                      {regVerifyChecking ? t("Checking...") : t("Confirm")}
                    </button>
                  </div>
                )}

                {regVerifyError && (
                  <p className="mt-2 text-sm text-red-500">{regVerifyError}</p>
                )}
              </div>
              <Field
                label={t("Password")}
                type="password"
                required
                onChange={(e) => setPassword(e.target.value)}
              />
              <div>
                <Field
                  label={t("Confirm Password")}
                  type="password"
                  required
                  onChange={(e) => setconpassword(e.target.value)}
                />
                {regError && (
                  <p className="mt-2 text-sm text-red-500">{regError}</p>
                )}
              </div>
              <button
                type="submit"
                className={primaryButtonClasses}
                disabled={!regEmailVerified || regVerifiedEmail !== email}
                style={!regEmailVerified || regVerifiedEmail !== email ? { opacity: 0.5, cursor: "not-allowed" } : undefined}
              >
                {t("Submit")}
              </button>
            </form>
            <button
              type="button"
              className="mt-6 text-center text-sm font-medium text-ink-500 hover:text-accent-500"
              onClick={() => {
                setislog(false);
                setisreg(true);
              }}
            >
              {t("Already have an account?")}
            </button>
          </div>

          <div
            className="flex-col items-stretch"
            style={{ display: !isforget || isverify ? "none" : "flex" }}
          >
            <h1 className="mb-6 font-display text-xl font-bold text-ink-900">
              {t("Reset password")}
            </h1>
            <p className="mb-6 text-sm text-ink-500">
              {t("Enter your email and you will receive a reset password link")}
            </p>
            <form className="flex flex-col gap-5" onSubmit={handleforget}>
              <Field label={t("email")} required type="email" onChange={(e) => setemail(e.target.value)} />
              <button type="submit" className={primaryButtonClasses}>
                {t("Submit")}
              </button>
            </form>
            {errorMessage && (
              <p className="mt-4 text-center text-sm text-accent-600">{errorMessage}</p>
            )}
          </div>

          <div
            className="flex-col items-stretch"
            style={{ display: isverify ? "flex" : "none" }}
          >
            <h1 className="mb-6 font-display text-2xl font-bold text-ink-900">
              {t("Verify your email")}
            </h1>
            <p className="mb-6 text-sm text-ink-500">
              {t("We sent a 6-digit code to")} <span className="font-medium text-ink-700">{verifyEmail}</span>
            </p>
            <form className="flex flex-col gap-5" onSubmit={handleVerifyCode}>
              <div>
                <Field
                  label={t("Verification code")}
                  required
                  type="text"
                  inputMode="numeric"
                  maxLength={6}
                  value={verifyCode}
                  onChange={(e) => setVerifyCode(e.target.value.replace(/\D/g, ''))}
                />
                {verifyError && (
                  <p className="mt-2 text-sm text-red-500">{verifyError}</p>
                )}
              </div>
              <div className="flex items-center justify-between text-sm text-ink-500">
                <span>
                  {secondsLeft > 0
                    ? `${t("Code expires in")} ${formatTime(secondsLeft)}`
                    : t("Code expired")}
                </span>
                <button
                  type="button"
                  className={linkClasses}
                  disabled={resendSecondsLeft > 0}
                  onClick={handleResendCode}
                  style={resendSecondsLeft > 0 ? { opacity: 0.5, cursor: "not-allowed" } : undefined}
                >
                  {resendSecondsLeft > 0
                    ? `${t("Resend code")} (${resendSecondsLeft}s)`
                    : t("Resend code")}
                </button>
              </div>
              <button type="submit" className={primaryButtonClasses}>
                {t("Verify")}
              </button>
            </form>
            <button
              type="button"
              className="mt-6 text-center text-sm font-medium text-ink-500 hover:text-accent-500"
              onClick={() => {
                setisverify(false);
                setislog(false);
                setisreg(true);
              }}
            >
              {t("Back to login")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
Login.propTypes = {
  setToken: PropTypes.func.isRequired,
};
export default Login;
